import { useMemo } from "react";

import { Tag, useGetAllTagsQuery } from "../../../redux/slices";
import { SportPlay } from "../../../types";
import { TMultiSelectItem, useMultiSelect } from "../../multi-select";
import { UseSelect } from "../types";

export type SelectTagItem = TMultiSelectItem<Tag>;

export const useSelectTags = <TPlay extends SportPlay>({ editingPlay, updatePlay }: UseSelect<TPlay>) => {
  const { data: tags } = useGetAllTagsQuery();

  const tagItems: SelectTagItem[] = useMemo(
    (): SelectTagItem[] => tags?.map((tag) => ({ ...tag, id: tag.tag_id, label: tag.name })) || [],
    [tags]
  );

  const selectedTags = useMemo(
    (): SelectTagItem[] =>
      editingPlay.tags ? editingPlay.tags.map((t) => ({ ...t, id: t.tag_id, label: t.name })) : [],
    [editingPlay]
  );

  const handleChangeTags = (items: SelectTagItem[]) => {
    updatePlay((prevValue) => ({ ...prevValue, tags: items }));
  };

  const tagSelect = useMultiSelect({ items: tagItems, initialSelectedItems: selectedTags, onChange: handleChangeTags });

  return { tagSelect };
};
